module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-464.b6aa48f.woff2";